module.exports = __webpack_public_path__ + "static/media/trip_delete.a218e7ce.svg";